import { getThemeImages } from '../Themes'

export default function serviceToImageMap(data, themeName = 'light') {
  const themeImages = getThemeImages(themeName)
  const images = []
  if (data && data.services) {
    data.services.forEach(image => {
      switch (image) {
        case 'TV':
          images.push(themeImages.tv)
          break
        case 'DATA':
          images.push(themeImages.mobile)
          break
        case 'ROAMING':
          images.push(themeImages.roaming)
          break
        case 'BROADBAND':
          images.push(themeImages.wifi)
          break
        case 'HOMEPHONE':
          images.push(themeImages.router)
          break
        default:
          break
      }
    })
  }

  return images
}
